import React from 'react';

export const Require = () => {
  return (
    <span className="text-danger ms-1 bold">*</span>
  );
}
